import qs from 'qs'
export const htmlEmailBuilder = ({
  to,
  subject,
  body,
}: {
  to?: string
  subject?: string
  body?: string
}): string => {
  let mailtoString = 'mailto:'

  if (to !== undefined) {
    mailtoString += to
  }

  const queryString = {
    subject,
    body,
  }

  mailtoString += '?' + qs.stringify(queryString)

  return mailtoString
}
